import type { IconType } from "react-icons";
import {
  RiDashboardLine,
  RiFileList2Line,
  RiNewspaperLine,
  RiQuestionLine,
} from "react-icons/ri";
import EntityIcons from "components/icons/entity-icons";
import usePermission from "hooks/use-permission";

export interface SidebarLink {
  key: string;
  label: string;
  icon: IconType;
  href: string;
  isExternal?: boolean;
  isDisabled?: boolean;
  isHidden?: boolean;
}

const useSidebarLinks = (): SidebarLink[] => {
  const [
    hasFundingSearchPermission,
    hasDealSearchPermission,
    hasWealthSearchPermission,
  ] = usePermission(["fundingSearch", "dealSearch", "wealthSearch"]);

  const hasWatchlistPermission = usePermission("advancedWatchlist");

  const sidebarLinks: SidebarLink[] = [
    {
      key: "dashboard",
      label: "Dashboard",
      icon: RiDashboardLine,
      href: "/",
    },
    {
      key: "company-search",
      label: "Company Search",
      icon: EntityIcons.company,
      href: "/search/company",
    },
    {
      key: "investor-search",
      label: "Investor Search",
      icon: EntityIcons.investor,
      href: "/search/investor",
    },
    {
      key: "funding-search",
      label: "Funding Search",
      icon: EntityIcons.funding,
      href: "/search/funding",
      isDisabled: !hasFundingSearchPermission,
    },
    {
      key: "deal-search",
      label: "Deal Search",
      icon: EntityIcons.deal,
      href: "/search/deal",
      isDisabled: !hasDealSearchPermission,
    },
    {
      key: "wealth-search",
      label: "Wealth Search",
      icon: EntityIcons.wealth,
      href: "/search/wealth",
      isHidden: !hasWealthSearchPermission,
    },
    ...(hasWatchlistPermission
      ? [
          {
            key: "watchlists",
            label: "Watchlists",
            icon: RiFileList2Line,
            href: "/watchlists",
          },
        ]
      : []),
    {
      key: "daily-stack",
      label: "The Daily Stack",
      icon: RiNewspaperLine,
      href: "https://www.privco.com/dailystack",
      isExternal: true,
    },
    {
      key: "help-center",
      label: "Help Center",
      icon: RiQuestionLine,
      href: "https://www.privco.com/help-center",
      isExternal: true,
    },
  ];

  return sidebarLinks;
};

export default useSidebarLinks;
